import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect'
import { ApplicationState } from '../store/index';

export const isAuthenticated = (state: ApplicationState): boolean => (state.account.currentUser
    && state.account.currentUser.expiration
    && new Date() < new Date(state.account.currentUser.expiration)
    && state.account.currentUser.userManager
    ? true : false)

export default connectedRouterRedirect({
    // The url to redirect user to if they fail
    redirectPath: '/login',
    authenticatedSelector: (state: ApplicationState) => isAuthenticated(state),
    wrapperDisplayName: 'UserIsAuthenticated'
})